import { render, staticRenderFns } from "./Condominio.vue?vue&type=template&id=4ccb00c1&"
import script from "./Condominio.vue?vue&type=script&lang=js&"
export * from "./Condominio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports